const normalizeBreadcrumbValue = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

export const DETAIL_VIEW_TABS = Object.freeze([
  { value: "details", label: "Details" },
  { value: "stages", label: "Stages" },
  { value: "matches", label: "Matches" },
  { value: "activities", label: "Activities" },
]);

export const COMPANY_PROFILE_TABS = Object.freeze([
  { value: "details", label: "Details" },
  { value: "leads", label: "Leads" },
  { value: "contacts", label: "Contacts" },
  { value: "jobs", label: "Jobs" },
  { value: "candidates", label: "Candidates" },
  { value: "activities", label: "Activities" },
]);

export function findTabLabel(tabs = [], activeValue) {
  const normalizedActiveValue = normalizeBreadcrumbValue(activeValue);
  if (!normalizedActiveValue) return "";

  const match = (Array.isArray(tabs) ? tabs : []).find((tab) =>
    [tab?.value, tab?.id, tab?.key, tab?.label].some(
      (candidate) => normalizeBreadcrumbValue(candidate) === normalizedActiveValue
    )
  );

  return String(match?.label || "").trim();
}
